export default __webpack_public_path__ + "static/media/44.e806a3d2.jpg";